import React, { Component } from 'react';
import { FooterComponent } from './FooterComponent.jsx';
import { HeaderComponent } from './HeaderComponent.jsx';

export class Layout extends Component {
    //displayName = Layout.name
    constructor(props) {
        super(props);
        this.state = {
            login: false,
            authorName: ''
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            authorName: nextProps.AuthorName
        });
    }

    updateParent(searchtext, contenttype, istitleonly, publication, author, pubduration, pubstartdate, pubenddate, searchMySub, btnSearch) {
        this.props.appCallBack(searchtext, contenttype, istitleonly, publication, author, pubduration, pubstartdate, pubenddate, searchMySub, btnSearch);
    }

    render() {
        return (

            <div className="Container">
                

                <HeaderComponent layoutCallback={this.updateParent.bind(this)} AuthorName={this.state.authorName} login={this.state.login} />

                <section className="col-12-1">
                    {this.props.children}

                </section >

                <FooterComponent />
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Layout.jsx